import { Filter } from '@ui/common/filter.tsx';

export const ManufacturerPicker = () => {
  return (
    <div className="flex flex-col gap-y-4 py-4">
      <p className="text-sm lg:text-base font-semibold text-[#222223]">
        Страна производитель
      </p>
      <div className="flex flex-row flex-wrap gap-3">
        <Filter>Казахстан</Filter>
        <Filter>Россия</Filter>
        <Filter>Узбекистан</Filter>
        <Filter>Кыргыстан</Filter>
        <Filter>Германия</Filter>
        <Filter>Австрия</Filter>
        <Filter>США</Filter>
      </div>
    </div>
  );
};
